module.exports = __webpack_public_path__ + "img/news_banner.7226ba2f.png";